import A from '../constants/actions';
import AppConfig from '../config/appConfig';
import LogLevels from '../constants/logLevels';
import Store from '../store';

export default class LoggerUtils {

  static debug(message) {
    LoggerUtils.log(LogLevels.debug, message);
  }

  static info(message) {
    LoggerUtils.log(LogLevels.info, message);
  }

  static warn(message) {
    LoggerUtils.log(LogLevels.warn, message);
  }

  static error(message) {
    LoggerUtils.log(LogLevels.error, message);
  }

  static fatal(message) {
    LoggerUtils.log(LogLevels.fatal, message);
  }

  static log(level, message) {
    if (level.order >= AppConfig.logLevel.order) {
      Store.dispatch(A.LOGGER_ADD_MSG, {
        date: Date.now(),
        level,
        message
      });
    }
  }

}